import React from 'react';
import EventSponsorCartContainer from '../../../Containers/UserContainer/EventSponsorCart';

const EventSponsorCartScreen = () => {
  return <EventSponsorCartContainer />;
};

export default EventSponsorCartScreen;
